import { css, cx } from '@linaria/atomic';
import { useCalendarState } from '../provider/calendar.provider';
import type { BaseAtomProps } from './calendar-atom.types';

const headerRow = css`
  display: flex;
  justify-content: space-between;
`;

const dayName = css`
  min-width: calc(100% / 7);
  flex: 1;
  text-align: center;
`;

export const CalendarWeekHeader = ({ className }: BaseAtomProps) => {
  const { dayNames } = useCalendarState();
  return (
    <div className={cx('cal__week-header', headerRow, className)}>
      {dayNames.map((name, indx) => (
        <span key={indx + name} className={cx('cal__week-dayname', dayName)} aria-hidden='true'>
          {name}
        </span>
      ))}
    </div>
  );
};
